import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import { logging } from 'gandi.redux-logger';

/**
 * Call handlers based on response status code
 * @param  {Object} handlers Handlers based on status (on200, on2XX, on40X)
 * @param  {Object} store    Redux store
 * @param  {Object} action   Redux action
 * @return {Promise}         Promise with fetcher response
 */
export function processByStatus(handlers) {
  var identity = function identity(x) {
    return x;
  };
  /**
   * Utility function to find all handlers matching
   */


  var getMatchingHandlers = function getMatchingHandlers(response) {
    var status = "".concat(response.status);
    var statuses = ['XXX', "".concat(status.slice(0, -2), "XX"), "".concat(status.slice(0, -1), "X"), status]; // find the best matching `on` handler

    var onHandler = statuses.reduce(function (currentHandler, attempt) {
      if (typeof handlers["on".concat(attempt)] === 'function') {
        return handlers["on".concat(attempt)];
      }

      return currentHandler;
    }, identity); // find all handlers not matching current status

    var notHandlers = Object.keys(handlers).filter(function (handlerName) {
      // remove non `not` handler
      if (handlerName.substr(0, 3) !== 'not') return false; // remove handlers with matching status

      return statuses.indexOf(handlerName.substr(3)) === -1;
    }).map(function (handlerName) {
      return handlers[handlerName];
    });
    return [onHandler].concat(_toConsumableArray(notHandlers));
  };

  return function (response) {
    return Promise.all(getMatchingHandlers(response).map(function (handler) {
      return handler(response);
    })).then(function () {
      return response;
    });
  };
}
/**
 * Default global handlers
 * @type {Object}
 */

var defaultHandlers = function defaultHandlers(logger) {
  return function (action) {
    return {
      onXXX: function onXXX(response) {
        if (process.env.NODE_ENV !== 'production') {
          logger.info({
            type: action.type,
            status: response.status
          }, "action (".concat(action.type, ") ") + "did not handle the following status code: ".concat(response.status));
        }
      }
    };
  };
};
/**
 * Redux middleware to call fetcher and process handlers based on response
 * status code.
 * @param  {Object}   fetcher
 * @param  {Object}   options Deault handlers based on response status code
 * @param  {Object}   store   Redux store
 * @param  {Function} next    To call next action
 * @param  {Object}   action  Current action called
 * @return {Promise}          fetcher promise
 */


export default function createFetcherMiddleware(fetcher) {
  return function (createHandlers) {
    return function (store) {
      return function (next) {
        return function (action) {
          if (!action.meta || !action.meta.http) {
            return next(action);
          }

          var payload = action.payload;
          var logger = logging(store.dispatch, 'gandi.redux-fetcher');
          var actionStart = Date.now();
          return payload.fetch(fetcher, store).then(function (response) {
            var actionTimeElapsed = (Date.now() - actionStart) / 1000;
            logger.info("".concat(action.type, " ").concat(response.url, " => ").concat(actionTimeElapsed, " sec"));
            return response;
          }).then(processByStatus(_objectSpread(_objectSpread(_objectSpread({}, defaultHandlers(logger)(action)), createHandlers(store)), payload.options || {})));
        };
      };
    };
  };
}